module.exports = __webpack_public_path__ + "img/134.2.15b8ba27.png";